import { useExpandedStateStore } from 'app/stores/ExpandedStateStore';

export function useTailorIsExpanded() {
  const isExpanded = useExpandedStateStore((state) => state.isExpanded);
  const setIsExpanded = useExpandedStateStore((state) => state.setIsExpanded);
  const isExpandAnimationComplete = useExpandedStateStore((state) => state.isExpandAnimationComplete);
  const setIsExpandAnimationComplete = useExpandedStateStore((state) => state.setIsExpandAnimationComplete);

  return { isExpanded, setIsExpanded, isExpandAnimationComplete, setIsExpandAnimationComplete };
}
